import { trackingService } from '@monthio/react-components'

export class MemoryStorage implements Storage {
	#storage = new Map<string, string>()

	constructor() {
		trackingService.trackEvent('flowWithMemoryOnlyStorage')
	}

	public readonly clear = () => {
		this.#storage.clear()
	}
	public readonly getItem = (key: string): string | null => {
		return this.#storage.get(key) ?? null
	}

	public readonly key = (): string | null => {
		throw new Error('Method not implemented.')
	}

	public readonly removeItem = (key: string) => {
		this.#storage.delete(key)
	}

	public readonly setItem = (key: string, value: string) => {
		this.#storage.set(key, value)
	}

	public get length() {
		return this.#storage.size
	}
}
